import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPeopleGroup,
  faHandshakeAngle,
  faUsers,
  faShieldHeart,
  faHandshake,
} from '@fortawesome/free-solid-svg-icons';

import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-section">
        <h2 className="mb-4">Aparna Western Meadows Owners Welfare Society</h2>
        <div className="about-description">
          <div className="about-text">
            <FontAwesomeIcon
              icon={faPeopleGroup}
              className="about-inline-icon me-2"
            />
            <p>
              Aparna Western Meadows Owners Welfare Society is a civic body
              representing the interests of owners in Aparna Western Meadows.
              Membership is voluntary, and leadership is typically elected by
              fee-paying members. The team comprises dedicated professionals
              such as engineers, software professionals, and independent
              entrepreneurs, etc.
            </p>
          </div>
          <div className="about-text">
            <FontAwesomeIcon
              icon={faShieldHeart}
              className="about-inline-icon me-2"
            />
            <p>
              Our society is registered under the Telangana Societies Act, 2001
              (Reg No. 1071/2017). The association was formed in 2017 with a
              specific agenda of providing safety, security, harmony, and basic
              amenities to all the owners. It is also responsible for
              transparency in communication and financial documentation. All our
              financial documents are audited by qualified chartered accountants
              and are available in MyGate for reference.
            </p>
          </div>
        </div>
      </div>

      <div className="about-grid">
        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faHandshakeAngle} />
          </div>
          <h4>Role and Functionality</h4>
          <p>
            Although AWMOWS is not an official government body, it plays a
            crucial role in addressing community issues. It works on matters
            such as sustainability, security, road lighting, cleanliness, safety
            measures, and water supply, etc. Active participation by owners
            ensures that AWMOWS functions effectively, providing a platform for
            addressing shared concerns and improving overall living conditions.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <h4>Community Involvement</h4>
          <p>
            By forming an organization like AWMOWS, residents can collectively
            create a congenial atmosphere for the benefit of all the owners and
            residents of Aparna Western Meadows. They can also collaborate to
            solve their problems. Participation in RWAs is not only essential
            for community improvement but also directly benefits individuals and
            their families.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faHandshake} />
          </div>
          <h4>Connected Neighbourhood</h4>
          <p>
            AWMOWS promotes a sense of togetherness in a close-knit society. In
            the modern era, living harmoniously within a community enhances
            connectivity and cooperation. By taking collective initiatives,
            owners can create a better environment for all.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
